import { AuthUserProp } from "modules/auth/users/store/actionType";
import { createContext, useContext, ReactNode, useEffect, useState } from 'react';
import { normalizeStoredActions, normalizeStoredSuperAdmin } from './userAuthorities';

type UserContextType = {
  authUser: AuthUserProp | null;
  setAuthUserProp: (user: AuthUserProp | null) => void;
  action: string[];
  setAction: (action: string[]) => void;
  superAdmin: string | null;
  setSuperAdmin: (value: string | null) => void;
};

const UserContext = createContext<UserContextType | undefined>(undefined);
export const UserProvider = ({ children }: { children: ReactNode }) => {
  const [authUser, setAuthUserProp] = useState<AuthUserProp | null>(null);
  const [action, setAction] = useState<string[]>([]);
  const [superAdmin, setSuperAdmin] = useState<string | null>(null);
  useEffect(() => {
    if (typeof window !== "undefined") {
      const user = sessionStorage.getItem("user");

      if (user) setAuthUserProp(JSON.parse(user ?? ''));

      const actions = sessionStorage.getItem("actions");
      if (actions) {
        try {
          setAction(normalizeStoredActions(JSON.parse(actions)));
        } catch {
          setAction([]);
        }
      }
      const storedSuperAdmin = sessionStorage.getItem("superAdmin");
      if (storedSuperAdmin) {
        try {
          setSuperAdmin(normalizeStoredSuperAdmin(JSON.parse(storedSuperAdmin)));
        } catch {
          setSuperAdmin(storedSuperAdmin);
        }
      }
    }
  }, []);
  return (
    <UserContext.Provider value={{ authUser, setAuthUserProp, action, setAction, superAdmin, setSuperAdmin }}>
      {children}
    </UserContext.Provider>
  );
};
export const useUser = () => {
  const context = useContext(UserContext);
  if (!context) throw new Error("useUser must be used within a UserProvider");
  return context;
};